<template>
	<div>
		<div class="couponWrap">
			<el-tabs v-model="listQuery.type" @tab-click="handleTabClick">
				<el-tab-pane :label="item.name" :name="item.id" v-for="(item, index) in tabList" :key="index">
					<div class="list">
						<el-row :gutter="10">
							<el-col :span="5">
								<el-input v-model="form.code" placeholder="请输入优惠券码绑定" size="small"></el-input>
							</el-col>
							<el-col :span="5">
								<el-button type="primary" icon="el-icon-plus" size="small"
									@click="bindCoupon">绑定优惠券</el-button>
							</el-col>
						</el-row>
						<div v-loading="loading">
							<el-empty :image-size="100" v-if="list.length == 0"></el-empty>
							<el-row v-for="(item, index) in list" :key="index" v-if="list.length > 0">
								<el-col :span="24">
									<el-card shadow="never" class="couponCard" :body-style="{ padding: '5px' }">
										<div slot="header">
											<el-row type="flex" align="middle">
												<el-col :span="11">
													<div class="title">
														<el-tag v-if="item.show_status == 0" effect="dark"
															size="small">{{
				item.show_status_name }}</el-tag>
														<el-tag v-else effect="dark" type="info" size="small">{{
				item.show_status_name
			}}</el-tag>
														<span class="couponName">{{ item.name }}</span>
														<template v-if="item.type == 0">
															<el-button type="text">满{{ item.amount }}减{{ item.price
																}}</el-button>
														</template>
														<template v-if="item.type == 1">
															<el-button type="text">{{ item.discount }}折</el-button>
														</template>
														<template v-if="item.type == 2">
															<el-button type="text">满{{ item.reach_num }}送{{
				item.give_num }}</el-button>
														</template>
													</div>
												</el-col>
												<el-col :span="13">
													<el-row type="flex" :gutter="30" align="middle"
														justify="space-between">
														<el-col :span="12">过期时间：{{ item.end_time }}</el-col>
														<el-col :span="12" v-if="item.use_time">使用时间：{{ item.use_time
															}}</el-col>
													</el-row>
												</el-col>
											</el-row>
										</div>
										<div class="listContent">
											<el-row type="flex" :gutter="10">
												<el-col :span="4">
													<img style="width: 100%;" :src="item.cover" alt="">
												</el-col>
												<el-col :span="10" class="tableGrid">
													<p>发放时间</p>
													<p>{{ item.get_time }}</p>
													<p>适用范围</p>
													<p>
														<template v-if="item.goods.length == 0">全场通用</template>
														<template v-else>
															{{ item.goods.map(item => item.name).join('、') }}
														</template>
													</p>
													<p>提示</p>
													<p>{{ item.limit ? '不可与其他优惠同享' : '不可与其他优惠同享' }}</p>
												</el-col>
												<el-col :span="10" class="tableGrid" v-if="item.order_no">
													<p>使用订单</p>
													<p>{{ item.order_no }}</p>
												</el-col>
											</el-row>
										</div>
									</el-card>
								</el-col>
							</el-row>
						</div>
						<el-pagination v-if="list.length > 0" style="text-align: center;margin-top: 20px;" background
							@size-change="handleSizeChange" @current-change="handleCurrentChange"
							:current-page="listQuery.page" :page-size="listQuery.pagesize" layout="prev, pager, next"
							:total="total">
						</el-pagination>
					</div>
				</el-tab-pane>
			</el-tabs>
		</div>
	</div>
</template>

<script>
import { getCouponList, bindCoupon } from '@/api/user'
export default {
	name: 'TouristCoupon',
	components: {

	},
	computed: {

	},
	data() {
		return {

			tabList: [
				{
					name: '全部',
					id: '0'
				},
				{
					name: '待使用',
					id: '1'
				},
				{
					name: '已使用',
					id: '2'
				},
				{
					name: '已过期',
					id: '3'
				}
			],
			loading: false,
			list: [],
			total: 0,
			listQuery: {
				type: '0',
				page: 1,
				pagesize: 10,
			},
			form: {
				code: null,
			}
		}
	},
	watch: {

	},
	created() {
		this.getList();
	},
	methods: {
		//兑换优惠券
		bindCoupon() {
			const _form = this.form;
			if (!_form.code) {
				this.$message({
					type: 'error',
					message: '请输入兑换码'
				});
				return;
			}
			this.loading = true;
			bindCoupon(_form).then((res) => {
				this.loading = false;
				this.$message({
					type: 'success',
					message: '兑换成功'
				})
				this.handleFilter();
			}).catch((err) => {
				this.loading = false;
			})
		},
		handleTabClick(tab, event) {
			this.handleFilter();
		},
		// 获取列表
		getList() {
			this.loading = true;
			const _listQuery = Object.assign({}, this.listQuery);
			getCouponList(_listQuery)
				.then((response) => {
					this.list = response.data.list;
					this.total = response.data.count * 1;
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},
		// 查询
		handleFilter() {
			this.listQuery.page = 1;
			this.getList();
		},
		// 更改每页行数
		handleSizeChange(val) {
			this.listQuery.pagesize = val;
			this.getList();
		},
		// 更改页码
		handleCurrentChange(val) {
			this.listQuery.page = val;
			this.getList();
		},
	}

}
</script>

<style lang="scss" scoped>
.couponWrap {
	width: 100%;
	background-color: #f7f7f7f7;
	padding-bottom: 20px;
	padding-top: 10px;
	min-height: 350px;

	.list {
		padding: 0 16.5px;

		.el-row {
			margin-bottom: 18px;

			&:last-child {
				margin-bottom: 0;
			}
		}

		.title {
			display: flex;
			align-items: center;
			column-gap: 10px;

			.couponName {
				font-weight: 650;
				font-style: normal;
				font-size: 16px;
				color: #000000;
			}
		}

		.couponCard {
			/deep/ .el-card__header {
				padding: 0 18px;
			}
		}

		.tableGrid {
			display: grid;
			grid-template-columns: 97px auto;
			column-gap: 15px;
			align-items: center;
			font-weight: 400;
			font-style: normal;
			font-size: 14px;
			color: #303133;

			:nth-child(odd) {
				text-align: right;
			}
		}
	}
}
</style>
